import React from 'react';

import {ChangeLogDrawerContent} from './change-log-drawer-content';

import type {DetailedLogHits} from 'src/openapi/admin/models/DetailedLogHits';
import type {Error} from 'src/openapi/admin/models/Error';

type Props = {
    selectedLogId: string | null,
    onClose: () => void,
    loader: (logId: string) => Promise<{
        type: string,
        payload: {
            data: DetailedLogHits,
            success: true,
            error: false,
        } | {
            data: Error,
            success: false,
            error: true,
        },
    }>,
};

export const ChangeLogDrawer = React.memo(({selectedLogId, onClose, loader}: Props) => (
    <ChangeLogDrawerContent
        onClose={onClose}
        selectedLogId={selectedLogId}
        open={!!selectedLogId}
        loader={loader}
    />
));
